import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import ExerciseSelection from './views/ExerciseSelection.vue';
import Devices from './views/Devices.vue';
import Capture from './views/Capture.vue';
import Settings from './views/Settings.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/exercise',
      name: 'exercise',
      component: ExerciseSelection,
    },
    {
      path: '/devices',
      name: 'devices',
      component: Devices,
    },
    {
      path: '/capture',
      name: 'capture',
      component: Capture,
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    },
    {
      path: '*', // or '/index.html'
      beforeEnter: (to, from, next) => {
        next('/');
      },
    },
  ],
});
